/**
 * Request - Service worker register method
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
export const addToHome = () => new Promise((resolve, reject) => {
        reject(new Error('Lo sentimos, se produjo algún error al inicializar el app'));
});


export const verify = () => {
    //if (document.location.hash === "#pwa=on") {
    //    Cookie.CreateCookie('LNpwaStatus', 'true');
    //    console.log('PWA Activo');
    //    document.location.hash = '';
    //}
    //else if(document.location.hash === "#pwa=off") {
    //    Cookie.CreateCookie('LNpwaStatus', 'false')
    //}            
    //const cookie = Cookie.LeerCookie('LNpwaStatus') === 'true';
    //console.log('SW: cookie ', cookie);
    //esto se puede comentar.
    //if (localStorage.getItem("pwaa") !== null && localStorage.getItem("pwaa") === "on") {
    //    console.log('SW: PWA Activo');
    //    return localStorage.getItem("pwaa") === "on" && ("serviceWorker" in navigator);
    //}
    //else if(localStorage.getItem("pwaa") !== null && localStorage.getItem("pwaa") === "off") {
    //    //Cookie.CreateCookie('LNpwaStatus', 'false')
    //    console.log('SW: PWA DESACTIVADOOOOOOOOOOOOOOOOOOOO');
    //    return false;
    //}          

    return true && ("serviceWorker" in navigator);
}
export const unregister = () => new Promise((resolve, reject) => {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.getRegistrations()
                .then(function (registrations) {
                    const length = (registrations || []).length;

                    for (let registration of registrations) {
                        console.log('SW: unreg', registration);
                        registration.unregister();
                    }

                    resolve(length);
                })
                .catch(function (err) {
                    console.log('SW: unreg ERROR', arguments);

                    reject(err);
                });
        } else {
            reject(new Error("serviceWorker == undefined"));
        }
});

export const register = () => {
    console.log('SW: xxx', ServiceWorker);

    return new Promise((resolve, reject) => {

        //window.addEventListener('load', function() {

        //    if(navigator.standalone || window.matchMedia('(display-mode: standalone)').matches) {
        //        document.querySelector('body').classList.add('pwa-mode-standalone');
        //    }

        //    const styleMedia = (window.styleMedia || {}).type || false;
        //    if(styleMedia) {
        //        document.querySelector('body').classList.add('pwa-media-' + styleMedia);
        //    }

        //    function updateOnlineStatus(event) {
        //        document.querySelector('body').classList.add('pwa-' + (navigator.onLine ? 'online' : 'offline'));
        //        document.querySelector('body').classList.remove('pwa-' + (navigator.onLine ? 'offline' : 'online'));
        //    }

        //    window.addEventListener('online',  updateOnlineStatus);
        //    window.addEventListener('offline', updateOnlineStatus);
        //});

        //window.addEventListener('beforeinstallprompt', e => {
        //    console.log('SW: app beforeinstallprompt Event fired', e);
        //    e.preventDefault();

        //    ServiceWorker.addToHome = () => {
        //        e.prompt();

        //        return e.userChoice;
        //    };

        //    const btn = document.createElement('button'); 
        //    btn.innerText = "Agregar a inicio";
        //    btn.onclick = () => { 
        //        ServiceWorker.addToHome();
        //    };
        //    document.querySelector('#cabezal > section > div.desplegable > div.tematicas > div.derecha > ul').appendChild(btn);

        //    return false;
        //});

        window.addEventListener('beforeinstallprompt', function (e) {
            // beforeinstallprompt Event fired
            dataLayer.push({
                'event': 'notificationPrompt'
            });
            // e.userChoice will return a Promise. 
            // For more details read: https://developers.google.com/web/fundamentals/getting-started/primers/promises
            e.userChoice.then(function (choiceResult) {

                console.log(choiceResult.outcome);

                if (choiceResult.outcome == 'dismissed') {
                    console.log('User cancelled home screen install');
                }
                else {
                    dataLayer.push({
                        'event': 'notificationConsent'
                    });
                }
            });
        });

        if ('serviceWorker' in navigator) {
            console.log("Will the service worker register?");
            navigator.serviceWorker.register('/sw.js')
                .then(function (reg) {
                    console.log("Yes, it did.");
                }).catch(function (err) {
                    console.log("No it didn't. This happened: ", err)
                });
        }



        //    try {    
        //        navigator.serviceWorker.register("/sw.js")
        //            .then(function (reg) {
        //                var status = reg.installing ? 1 : reg.waiting ? 2 : reg.active ? 3 : 0;
        //                console.log('SW: reg ', reg);
        //                console.log('SW: status', status == 1 ? 'installing' : status == 2 ? 'waiting' : status == 3 ? 'active' : 'none' );

        //                var sw = reg.active;

        //                reg.addEventListener('updatefound', () => {
        //                    var newSW = reg.installing;
        //                    document.querySelector('body').classList.add('pwa-updating');

        //                    console.log('SW: newSW', newSW);
        //                    if(!!newSW) newSW.onstatechange = function (e) {
        //                        var o = e.target;
        //                        console.log('SW: status change new', o.state);

        //                        if ("activated" === o.state && sw) {
        //                            window.location.reload();
        //                        }
        //                    };
        //                });

        //                reg.onstatechange = function (e) {
        //                    var o = e.target;
        //                    console.log('SW: status change', o.state);

        //                    document.querySelector('body').classList.add('pwa-state-' + o.state);
        //                };

        //                resolve({ ok:true, sw: sw, reg: reg });
        //            })
        //            .catch(function (e) {
        //                reject({error: e, ok: false});
        //            });
        //    } catch(err) {
        //        reject({ok:false, message:"Service workers are not supported.", error: err});
        //    }
        //});
    });
}



// WEBPACK FOOTER //
// ./Statics/pwa/register.js